import React from "react";

const NotFound = () => {
  return (
    <div className="text-center text-red-500">
      <p>Page not Found</p>
    </div>
  );
};

export default NotFound;
